import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useViewport } from "../../../../context/viewport";
import { breakpoints } from "../../../../utils/constants";

interface Props {}

const AlreadyPendingStep: React.FC<Props> = () => {
  const { width } = useViewport();

  const isMobile = useMemo(() => width < breakpoints.md, [width]);

  return (
    <>
      <p className="mb-4">
        Oops, it looks like the wallet with the hotspots to the{" "}
        {isMobile ? "bottom" : "right"} of this page was already being verified
        by another workspace. A wallet can only be verified by one workspace.
      </p>
      <p className="mb-4">
        Please switch to the relevant workspace to manage the hotspots of this
        wallet. In case of confusion you can send a message to any hotspot of
        this wallet.
      </p>

      <div className="flex-shrink-0 px-4 py-4 flex justify-end">
        <Link
          to="/workspace/wallets"
          className="ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-hotspotty-400 hover:bg-hotspotty-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-hotspotty-400 flex items-center disabled:opacity-50 disabled:cursor-default"
        >
          Go to wallets
        </Link>
      </div>
    </>
  );
};

export default AlreadyPendingStep;
